export const PROFILE = {
  name: "Harshith Holla",
  role: "Visual Designer & Animator",
  titleLine: "Visual Designer | Brand & Campaign Design | Digital Content",
  location: "Middlesbrough, United Kingdom",
  email: "hollaharsha103@gmail.com",
  heroImage: "/portrait.png",
  portrait: "/portrait.png",
  behance: "https://www.behance.net/travelpartner",
  resume: "https://www.behance.net/travelpartner/resume",
  linkedin: "https://shorturl.at/lOZlP",
  facebook: "https://www.facebook.com/harshithholla",
  whatsapp: "https://wa.me/447425734872",
  whatsappDisplay: "+44 7425 734872",
  linktree: "https://linktr.ee/harshiholla",
};

export const EXPERIENCE = [
  {
    role: "2D Artist & Illustrator",
    company: "KingBee Animation, London (Remote)",
    dates: "Sep 2025 — Dec 2025",
    points: [
      "Created illustrations, concept artwork and digital assets for animation projects.",
      "Collaborated with creative teams to deliver engaging visual content.",
      "Maintained visual and artistic consistency across projects.",
    ],
  },
  {
    role: "General Manager & Creative Lead",
    company: "Spearhead Media Pvt Ltd & Quick Advisory & Digital, India",
    dates: "May 2022 — Jul 2024",
    points: [
      "Progressed from Chief Graphic Designer to Production Coordinator, Operations Manager and Creative Head / General Manager.",
      "Led creative marketing campaigns across digital, social and promotional platforms, maintaining brand consistency.",
      "Designed marketing materials, social graphics, ads, branding assets and print literature for multiple clients.",
    ],
  },
  {
    role: "Game Producer",
    company: "Booboo Games Pvt Ltd (Zhakaas Games LLP), India",
    dates: "Apr 2021 — Apr 2022",
    points: [
      "Progressed from Game Designer and Storyboard Artist to Game Producer.",
      "Created storyboards and visual sequences for concepts, character actions and narrative direction.",
      "Coordinated artists, designers and developers to keep production on schedule.",
    ],
  },
  {
    role: "Creative Head",
    company: "The Wonder Bloggers, India",
    dates: "Nov 2018 — Apr 2021",
    points: [
      "Co-founded and helped lead a YouTube channel with a 10-person team.",
      "Led creative development from ideas and scripting through production and final delivery.",
      "Helped grow the channel to 165,000+ views within two months.",
    ],
  },
];

export const EDUCATION = [
  { degree: "MA in Animation", school: "Teesside University, United Kingdom", years: "2024 — 2026" },
  { degree: "Bachelor's Degree", school: "Srinivas University, Mangalore, India", years: "2021" },
];

export const AWARDS = [
  { title: "“A Budding Journalist”", org: "CEMCA & UNESCO, Delhi", year: "2020" },
  { title: "“Butterfly”", org: "Thakur University, Mumbai & CEMCA & UNESCO, Lucknow", year: "2019" },
  { title: "“Pixilation”", org: "Alva's Shikshana Pratistana, Moodabidri", year: "2019" },
];

export const CORE_SKILLS = [
  "Visual design, layout & composition",
  "Typography, colour & visual hierarchy",
  "Brand identity & campaign design",
  "Digital, social media & marketing assets",
  "Print: brochures, flyers, leaflets & posters",
  "Creative concepts & visual storytelling",
  "Presentation-ready & promotional design",
  "Illustration, motion graphics & animation",
  "Creative collaboration & project coordination",
  "Quality control & attention to detail",
];

export const SOFTWARE = [
  { name: "Adobe Photoshop", icon: "/software/photoshop.svg" },
  { name: "Adobe Illustrator", icon: "/software/illustrator.svg" },
  { name: "Adobe InDesign", icon: "/software/indesign.png" },
  { name: "Adobe After Effects", icon: "/software/aftereffects.svg" },
  { name: "Adobe Premiere Pro", icon: "/software/premierepro.svg" },
  { name: "Adobe Lightroom", icon: "/software/lightroom.png" },
  { name: "Autodesk Maya", icon: "/software/maya.svg" },
  { name: "Microsoft Office", icon: "/software/msoffice.svg" },
];

const driveThumb = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w800`;
const driveView = (id) => `https://drive.google.com/file/d/${id}/view`;

const BEHANCE = [
  {
    title: "Luxury Invitation Design",
    category: "Print / Invitation",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/132896254658429.Y3JvcCwxOTk5LDE1NjQsMCw3MTc.png",
    url: "https://www.behance.net/gallery/254658429/LUXURY-INVITATION-DESIGN",
  },
  {
    title: "Accessories Print Design",
    category: "Print / Editorial",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/9bcb59254658341.Y3JvcCwxMDM1LDgxMCwyMyww.png",
    url: "https://www.behance.net/gallery/254658341/ACCESSORIES-PRINT-DESIGN",
  },
  {
    title: "Public Relations Council of India",
    category: "Branding / Identity",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/d6392c254657665.Y3JvcCw1MDAwLDM5MTAsMCw1NDQ.png",
    url: "https://www.behance.net/gallery/254657665/PUBLIC-RELATIONS-COUNCIL-OF-INDIA",
  },
  {
    title: "Certificate Design",
    category: "Print / Stationery",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/d26df9254657577.Y3JvcCwxNTM0LDEyMDAsMTMyLDA.png",
    url: "https://www.behance.net/gallery/254657577/CERTIFICATE-DESIGN",
  },
  {
    title: "Logo Design",
    category: "Branding / Marks",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/9b0481254657315.Y3JvcCw3OTcyLDYyMzYsMzQ5Miww.jpg",
    url: "https://www.behance.net/gallery/254657315/LOGO-DESIGN",
  },
  {
    title: "Magazine / Brochure Design",
    category: "Editorial / Layout",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/1e85ba254657133.Y3JvcCwyMzExLDE4MDcsMCwyMg.png",
    url: "https://www.behance.net/gallery/254657133/MAGAZINE-BROCHURE-DESIGN",
  },
  {
    title: "ID Card Design",
    category: "Print / Identity",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/cd9798254657035.Y3JvcCwyNTY2LDIwMDcsMCwzNjg.jpg",
    url: "https://www.behance.net/gallery/254657035/ID-CARD-DESIGN",
  },
  {
    title: "Business Card Design",
    category: "Print / Stationery",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/5d57a6254656823.Y3JvcCwzMDY4LDI0MDAsNjgsMA.jpg",
    url: "https://www.behance.net/gallery/254656823/BUSINESS-CARD-DESIGN",
  },
];

const PROMO = [
  { title: "Cadbury Crunchy Melts", id: "1OUC92hHLz8ZO178qCqCA0UnEaltTii-L" },
  { title: "Cadbury Roses", id: "1zp6kex_MoOqylw39p4so14loIqvMG-Cf" },
  { title: "Costa Coffee", id: "1m4QimiCJrAJtSYExR_AFZ4BqkrtWoB1q" },
  { title: "Fanta Orange", id: "1zTP2IY_E96HQvsMYlLtmB3fJyIm-aOiW" },
  { title: "KP Peanuts", id: "1Q-UrVxddxwLO_W8VjXnOem_dXa6gpXB5" },
  { title: "Mayo Campaign", id: "1FkAkagzjAXq-5t94Jyosbm_Isq6tmdnI" },
  { title: "Milkshakes Campaign", id: "1eES38I4OyQowMYsf7e1B7sAIAhfrjjKb" },
  { title: "Mini Cheddar", id: "1eHtRImitrn5TYmzIp0dWabK9yaoWGt73" },
  { title: "Pepsi Max Cherry", id: "1_gdOspTEthmUrbHp0jwKluYEkf8xY3X9" },
  { title: "Rice Crispies", id: "1aT8HJrJvdE59293Q6-6FK2QiKY1Ct5Di" },
  { title: "Schweppes", id: "17mRwS_oEs2cDA55QnbvUPWwR7WW5qtA4" },
  { title: "Seabrook Curls & Puffs", id: "1W9HTZKrNxvrQcvhMA5nillO9r8lOJwrv" },
].map((p) => ({ ...p, category: "Promotional / Product", image: driveThumb(p.id), url: driveView(p.id) }));

const POSTERS = [
  { title: "Sunthladi — Official Poster", category: "Poster / Film", id: "1sha25l-1vrp3ZCQJsxbuiTNcJKOM26hd" },
  { title: "Teacher's Day Poster", category: "Poster / Occasion", id: "1Aie9nnhwtMnZi_iw8fNpXg2FCOOQ08To" },
  { title: "Ugadi Festival Poster (English)", category: "Poster / Festival", id: "15Qc6IwkD5EkB9AHiHQUL-GQoUmzzR3Tg" },
  { title: "Ugadi Festival Poster (Kannada)", category: "Poster / Festival", id: "1Y-HCdTHWQeeTbThwPLtj7tZOZ8D9Wlhu" },
  { title: "YouTube Cover Page Design", category: "Digital / Cover", id: "14rcLjtHeYknRsJZCowKHQLK7HeHlrhBX" },
  { title: "Event Poster (English)", category: "Poster / Event", id: "1S4ypRCY8h1Qa5B583k_JPPvU11Qyl-rg" },
  { title: "Event Poster (Kannada)", category: "Poster / Event", id: "1p4TG5jEVPjJaFJhNDlTXXMprBlLqSwB-" },
].map((p) => ({ ...p, image: driveThumb(p.id), url: driveView(p.id) }));

const GRAPHIC = [
  { title: "10th Anniversary Artwork I", category: "Graphic Design", id: "19oS_J-vNTAXuezmJobX4wgOzKnsxWZIW" },
  { title: "10th Anniversary Artwork II", category: "Graphic Design", id: "10zcN6aK_4gx9Dbc4QyjlagyfjXsKfsI_" },
  { title: "Portrait Invitation — Revised", category: "Graphic Design", id: "18ZJyS5or4shxmLYgJLAQZxmKsEb7uEGT" },
  { title: "OTP Page Design", category: "Digital / UI", id: "1HB2-LZRvMY8RvtPxzD7kz5piPFMyQBB7" },
  { title: "Photorealistic Mockup", category: "Graphic Design", id: "1gijsdNL2oMeaHUwS9pFiKb8MufSeoqjh" },
].map((p) => ({ ...p, image: driveThumb(p.id), url: driveView(p.id) }));

const SHOWREELS = [
  {
    title: "Harshith Animation Showreel",
    category: "Showreel",
    image: "https://ugc.production.linktr.ee/d6ce773b-ed40-4bd7-8603-167a48727013_canva-design.png?io=true&size=thumbnail-stack_v1_0",
    url: "https://drive.google.com/file/d/19x_9M1UjHcEfJQ90RiswrbdHjRzf-HmP/view",
  },
  {
    title: "Realistic Animation",
    category: "Showreel / 3D",
    image: "https://ugc.production.linktr.ee/dcc255d0-45e7-4c45-afb4-f8beacc66a52_Screenshot-2026-05-14-003133.png?io=true&size=thumbnail-feature-v1_0",
    url: "https://drive.google.com/file/d/19EFQtifsNz2_UG90IACiy1U-PVOQg8AX/view",
  },
  {
    title: "Stylized Animation Reel",
    category: "Showreel",
    image: "https://ugc.production.linktr.ee/20994a0f-1431-4f4f-9d65-643ae30a521d_Screenshot-2026-05-14-001857.png?io=true&size=thumbnail-stack_v1_0",
    url: "https://drive.google.com/file/d/1snyGKBf7SxKMwPM0iFcJ9xYSNp5_u6tF/view",
  },
  {
    title: "Creature Animation",
    category: "Showreel / Creature",
    image: "https://ugc.production.linktr.ee/46c93947-4220-48da-ab5e-7c4b84286eae_Screenshot-2026-05-21-203047.png?io=true&size=thumbnail-stack_v1_0",
    url: "https://drive.google.com/file/d/1WAEj3lEdpPYV1uMpw67BbvZGCfG_5OKX/view",
  },
  {
    title: "Body Mechanics Animation Reel",
    category: "Showreel / Body Mechanics",
    image: "https://ugc.production.linktr.ee/93275811-e4c0-4045-bad7-b7872ba08df0_Screenshot-2026-05-21-203528.png?io=true&size=thumbnail-stack_v1_0",
    url: "https://drive.google.com/file/d/1udSDh02BFwJrmm0xYuEJ7QDaNwAEw55r/view",
  },
  {
    title: "Acting Animation",
    category: "Showreel / Acting",
    image: "https://ugc.production.linktr.ee/250c155a-1b96-4ac4-a75f-a935395f9f16_AntonioVieira-AristotleComp3279-580345-13-TransparentWhite-1.jpeg?io=true&size=thumbnail-stack_v1_0",
    url: "https://drive.google.com/file/d/1qFLtVvpo-AgAs0f1MrS8of93oqXy3-dM/view",
  },
  {
    title: "Animation Replication Study",
    category: "Showreel / Study",
    image: "https://ugc.production.linktr.ee/af5fecac-f8e7-4e2c-a7ec-22bc6e477118_Screenshot-2026-05-21-203745.png?io=true&size=thumbnail-stack_v1_0",
    url: "https://drive.google.com/file/d/1TGErdwQ9-tO8gTzjt3sI_CfAcfXyLtIq/view",
  },
];

const MOTION = [
  { title: "Academy Promo Video", category: "Motion Graphics", id: "1dWn58nceqtOtEPI_S90MI7KmdQjA6coV" },
  { title: "Aruvade Bhootale (Kannada)", category: "Motion Graphics", id: "13ph-dEHDczPCGsHMEMSEcr7lIFGE1dwb" },
  { title: "Decennial Ad", category: "Motion Graphics / Ad", id: "17vPA6BLM9HxKKhpCQjJiux1nLgd8cR_J" },
  { title: "Franchise Promo", category: "Motion Graphics", id: "1A5TUje3foJISbSUVj0cqrz9CxIR4fh-i" },
  { title: "Village TV Fundraiser", category: "Motion Graphics", id: "1DNAT1kun7RbBVay5t4kAYe8uDYhAchCO" },
  { title: "Yer Nammakulu", category: "Motion Graphics", id: "1Bz6rK2kpafDdz2KuFtp_MyeSKYpT4vx0" },
].map((p) => ({ ...p, image: driveThumb(p.id), url: driveView(p.id) }));

const ANIMATION_2D = [
  { title: "2D Animation Reel", category: "2D Animation", id: "12Tv0cM8b_OoV4q9ZqDK0lgMySF06Iene" },
  { title: "COVID-19 Awareness", category: "2D Animation / PSA", id: "1WJbgrootzIlCUAmVPWWeAsdigKwQzffa" },
  { title: "Curfew", category: "2D Animation / Short", id: "1RVBN0h8GSWiYJMi4mi7Ns1GestGJc7lY" },
  { title: "Lockdown", category: "2D Animation / Short", id: "1Jb7rKadl3qGlqZqrpCGX8uWb0N6Kx9lI" },
].map((p) => ({ ...p, image: driveThumb(p.id), url: driveView(p.id) }));

const UIUX = [
  {
    title: "Take 2 — Mobile App",
    category: "Mobile App / Google Play",
    image: "https://play-lh.googleusercontent.com/nLxTv-_xa-qhe6kVEjxHnc1DFEqaWhpOWgbLPNZe7KjJCbzGTmDgdMUm22xPaMg4nj3of2Z4_S8BaDiiXF3_n6A=w512",
    url: "https://play.google.com/store/apps/details?id=vedam.take2",
  },
  {
    title: "UI/UX Design",
    category: "Digital / Product",
    image: "https://mir-s3-cdn-cf.behance.net/projects/808/59c7a5254656539.Y3JvcCwzNzc3LDI5NTQsMCwxODY.png",
    url: "https://www.behance.net/gallery/254656539/UIUX-DESIGN",
  },
];

export const PORTFOLIO_GROUPS = [
  { id: "brand-print", heading: "Brand, Print & Editorial", sub: "Featured on Behance", video: false, items: BEHANCE },
  { id: "uiux-design", heading: "UI/UX Design", sub: "Apps & digital product design", video: false, items: UIUX },
  { id: "promotional-posters", heading: "Promotional Posters", sub: "Product & brand promo creatives", video: false, items: PROMO },
  { id: "poster-design", heading: "Poster Design", sub: "Posters, covers & occasions", video: false, items: POSTERS },
  { id: "graphic-design", heading: "Graphic Design Works", sub: "Artworks, pages & mockups", video: false, items: GRAPHIC },
  { id: "showreels", heading: "Animation Showreels", sub: "Video reels — opens in Drive player", video: true, items: SHOWREELS },
  { id: "motion-graphics", heading: "Motion Graphics", sub: "Ads & promo films — opens in Drive player", video: true, items: MOTION },
  { id: "2d-animation", heading: "2D Animation", sub: "Shorts & PSAs — opens in Drive player", video: true, items: ANIMATION_2D },
];

export const SERVICES = [
  { icon: "PenTool", title: "Print Design", text: "Invitations, certificates, business and ID cards — crafted with typographic precision and a luxury finish." },
  { icon: "Fingerprint", title: "Brand Identity", text: "Logos and identity systems that give organisations a distinct, memorable voice across every touchpoint." },
  { icon: "BookOpen", title: "Editorial & Layout", text: "Magazines and brochures composed with strong grids, rhythm and editorial restraint." },
  { icon: "MonitorSmartphone", title: "UI/UX Design", text: "Clean, usable digital interfaces designed around real user journeys and modern product thinking." },
  { icon: "Clapperboard", title: "2D Animation", text: "Motion and frame-by-frame craft for film, brands and social — from showreels to full shorts." },
  { icon: "Boxes", title: "3D Animation", text: "Realistic, stylized and creature animation — body mechanics, acting shots and cinematic 3D storytelling." },
  { icon: "Palette", title: "Visual Design", text: "Posters, covers and occasion creatives with bold colour, composition and festival-ready polish." },
  { icon: "Film", title: "Motion Graphics", text: "Ads, promos and title sequences that move — kinetic type, transitions and brand films." },
  { icon: "Compass", title: "Art Direction", text: "Cohesive visual direction that ties print, brand and digital work into one clear story." },
];
